import { useMutation } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';
import { OnboardingCompanyDocument } from 'features/Onboarding/graphql/queries/onboardingCompany.gql';
import { throwIfErrorPresent } from 'features/Onboarding/utils';

import { UpdateHasFinishedProfileSetupDocument } from './updateHasFinishedProfileSetup.gql';

/**
 * TODO  hasFinishedProfileSetup should be set to true on the back end side for flexibility and security reasons
 * @see: https://github.com/shinetools/web-app/pull/3987#issuecomment-724152687
 */
const useFinishProfileSetupMutation = () => {
  const { companyProfileId } = useCompanyContext();

  const [updateHasFinishedProfileSetup, { error, loading }] = useMutation(
    UpdateHasFinishedProfileSetupDocument,
    {
      awaitRefetchQueries: true,

      /**
       * Reloading the full onboardingCompany is quite important because a lot of statuses may change at this point.
       * Including companyProfile.hasFinishedApplicationSetup... but refetching only this one doesn't seem to actually update it.
       */
      refetchQueries: [
        { query: OnboardingCompanyDocument, variables: { companyProfileId } },
      ],
      variables: {
        metadata: {
          hasFinishedProfileSetup: true,
        },
      },
    },
  );

  throwIfErrorPresent(error);

  const finishProfileSetup = async () => {
    await updateHasFinishedProfileSetup();
  };

  return {
    finishProfileSetup,
    isSaving: loading,
  };
};

export default useFinishProfileSetupMutation;
